module.exports = __webpack_public_path__ + "labioplastika_11_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_11_after_tn.jpg
// module id = 1533
// module chunks = 0